import { IPartialCSS } from "partnerbuilder-common";
import {
    FontStyles,
    ColorStyles,
    WidthStyles,
    AlignStyles,
    HeightStyles,
    MarginStyles,
    PaddingStyles,
    BackgroundStyles
} from "./GroupsStyles.static";

export const ContactFormStyles: IPartialCSS<true> = {
    ...FontStyles,
    ...WidthStyles,
    ...ColorStyles,
    ...AlignStyles,
    ...HeightStyles,
    ...MarginStyles,
    ...PaddingStyles,
    ...BackgroundStyles
};
